import { BufferAttribute, BufferGeometry } from 'three'
import data from './generated/blender-roster.json'
import { type MeshRecipe, type PartKind } from './meshes.js'
import { RigidWalk } from './rigid-walk.js'

const sources = new Map(data.map(recipe => [recipe.id, recipe]))

export function blenderRecipe(kind: number): MeshRecipe | undefined {
  const source = sources.get(kind)
  if (!source) return undefined
  return {
    copies: source.copies,
    parts: source.parts.map(part => {
      const geometry = new BufferGeometry()
      geometry.setAttribute('position', new BufferAttribute(new Float32Array(part.positions), 3))
      geometry.setAttribute('normal', new BufferAttribute(new Float32Array(part.normals), 3))
      geometry.setAttribute('shade', new BufferAttribute(new Float32Array(part.shades), 1))
      geometry.setAttribute('panel', new BufferAttribute(new Float32Array(part.shades.length * 4), 4))
      geometry.setIndex(part.indices)
      return { kind: part.kind as PartKind, geometry, walk: part.walkFrames ? new RigidWalk(part.walkFrames) : undefined }
    }),
  }
}
